
import { CollectionDetailEntity, EMPTY_COLLECTION_DETAIL_ENTITY } from "domain/entity/Collection/CollectionDetailEntity";
import { CollectionHeaderEntity } from "domain/entity/Collection/CollectionHeaderEntity";
import { AdditionChargeVesselEntity, EMPTY_ADDITIONAL_CHARGE_VESSEL_ENTITY } from "domain/entity/CounterCustomerCharge/AdditionChargeVesselEntity";
import { CounterCustomerChargeEntity, EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeSearchCriteria, EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeSearchCriteria";
import { EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA, PaymentModeAdditionalInfoCriteria } from "domain/entity/CounterCustomerCharge/PaymentModeAdditionalInfoCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface CounterCustomerChargeDropdownOptions {
    chgTypeDropdownOptions: DropdownProps[],
    chgTypeByUserDropdownOptions: DropdownProps[],
    subChgTypeDropdownOptions: { [key: string]: DropdownProps[] },
    subChgTypeByUserDropdownOptions: { [key: string]: DropdownProps[] },
    opsLineDropdownOptions: DropdownProps[],
    chgOnCompDropdownOptions: DropdownProps[],
    billToCompDropdownOptions: DropdownProps[],
    serviceCodeDropdownOptions: DropdownProps[],
    agentNoDropdownOptions: DropdownProps[],
    shipperConsigneeDropdownOptions: DropdownProps[],
    cntrSizeDropdownOptions: DropdownProps[],
    waiverReasonCodeDropdownOptions: DropdownProps[],
    acctTmlReasonCodeDropdownOptions: DropdownProps[],
    cntrTypeDropdownOptions: DropdownProps[],
    statusDropdownOptions: DropdownProps[],
    tariffTypeDropdownOptions: DropdownProps[],
    tariffCodeDropdownOptions: { [key: string]: DropdownProps[] },
    serviceRequestCodeDropdownOptions: DropdownProps[],
    allSubReqServiceCodeDropdownOptions: DropdownProps[],
    subServiceRequestCodeDropdownOptions: { [key: string]: DropdownProps[] },
    bankCodeDropdownOptions: DropdownProps[],
    allCCChgOnCompDropdownOptions: DropdownProps[],
    allCCBillToCompDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
    editingEntity: CounterCustomerChargeEntity,
}
export interface PaidThroughDateState {
    cntrNo: string;
    paidThroughDate: Date;
}

export interface ExtensionPaymentState {
    cntrNo: string;
    previousPaidThroughDate: Date | null;
    paidThroughDate: Date;
}

export interface AgentDeliveryDateState {
    cntrNo: string;
    agentDeliveryDate: Date;
}

export interface AdditionalChangeState extends BaseViewChangeSate {
    editingEntity: CounterCustomerChargeEntity,
    tableData: CounterCustomerChargeEntity[],
    isShowEditPanel: boolean,
    isShowDeleteModal: boolean,
    forceRefresh: boolean,
    currentSelectedRow: CounterCustomerChargeEntity,
    selectedRows: CounterCustomerChargeEntity[],
    vesselTableData: AdditionChargeVesselEntity[],
    currentSelectedVesselRow: AdditionChargeVesselEntity,
}

export interface PaymentModeState extends BaseViewChangeSate {
    tableData: CollectionDetailEntity[],
    editingEntity: CollectionDetailEntity,
    isBankCode: boolean;
    isPayOrderNo: boolean;
    isPayOrderAmount: boolean;
    isCreditCardNo: boolean;
    paymentModeHeader: PaymentModeAdditionalInfoCriteria,
    collectionHeaderList: CollectionHeaderEntity[],
    servicePayAmount: number,
    isCustomsDec: boolean;
    isAgentDate: boolean;

}

export interface CounterCustomerChargeMaintenanceModel {
    isLoading: boolean,
    tableData: CounterCustomerChargeEntity[],
    currentSelectedRow: CounterCustomerChargeEntity,
    selectedRows: CounterCustomerChargeEntity[],
    dynamicOptions: CounterCustomerChargeDropdownOptions,
    masterState: MasterChangeState,
    additionalState: AdditionalChangeState,
    paymentModeState: PaymentModeState,
    isBackMaster: boolean,
    isShowEditPanel: boolean,
    isShowDetailPanel: boolean,
    searchCriteria: CounterCustomerChargeSearchCriteria,
    isShowAdditionalChargePanel: boolean,
    isShowPaidThroughDatePanel: boolean,
    isShowInvoiceInfoPanel: boolean,
    isShowChargeOnCompanyPanel: boolean,
    isShowBillToCompanyPanel: boolean,
    isShowWaiverReasonCodePanel: boolean,
    isShowSuppleWaiverPanel: boolean,
    isShowAdjustmentPanel: boolean,
    isShowStuffingPanel: boolean,
    isShowChargeQtyPanel: boolean,
    isShowExtraLaborPanel: boolean,
    isShowAccTerminalPanel: boolean,
    isShowAgentDeliveryDatePanel: boolean,
    isShowExtensionPaymentPanel: boolean,
    isEnabledEditWaiver: boolean,
    isEnabledSuppleWaiver: boolean,
    isEnabledWaiver: boolean,
    isEnabledChargeCom: boolean,
    isEnabledBillCom: boolean,
    isEnableExciseCashNo: boolean,
    isEnablePaidThroughDate: boolean,
    isEnableChargeQty: boolean,
    isEnableExtraLabor: boolean,
    isEnableAccTerminal: boolean,
    isEnableHoldUnhold: boolean,
    isEnableAgentDeliveryDate: boolean,
    isEnableExtensionPayment: boolean,
    isEnableMarkMT: boolean,
    isEnableDelete: boolean,
    isEnableAdjustment: boolean,
    isEnableCfsStuffing: boolean,
    isEnableImporiReHandling: boolean,
    isEnablePreview: boolean,
    editingEntity: CounterCustomerChargeEntity,
    isShowFindVesselPanel: boolean,
    isShowPaymentModePanel: boolean,
    isShowAddPaymentModePanel: boolean,
    allSLCompanies: string[],
    editWaiverList: number[],
    suppleWaiverList: number[],
    singleMultipleValidationMap: { [key: string]: object },
    returnCntrNo: string[],
    returnBlNo: string,
    paidThroughDateMap: Map<string, Date>,
    agentDeliveryDateMap: Map<string, Date>,
    extensionPaymentMap: Map<string, Date>,
    previousPaidThroughDateMap: Map<string, Date>,
    isShowSerachClose: boolean,
    selectedPaidThroughDateMap: Map<string, Date>,
    selectedAgentDeliveryDateMap: Map<string, Date>,
    allFormState: { [key: string]: string },
}

export const EMPTY_MASTER_COUNTER_CUSTOMER_CHARGEANY_MODEL: CounterCustomerChargeMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY },
    editingEntity: { ...EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        chgTypeDropdownOptions: [],
        chgTypeByUserDropdownOptions: [],
        subChgTypeDropdownOptions: {},
        subChgTypeByUserDropdownOptions: {},
        opsLineDropdownOptions: [],
        chgOnCompDropdownOptions: [],
        billToCompDropdownOptions: [],
        serviceCodeDropdownOptions: [],
        agentNoDropdownOptions: [],
        shipperConsigneeDropdownOptions: [],
        cntrSizeDropdownOptions: [],
        cntrTypeDropdownOptions: [],
        statusDropdownOptions: [],
        tariffTypeDropdownOptions: [],
        tariffCodeDropdownOptions: {},
        waiverReasonCodeDropdownOptions: [],
        acctTmlReasonCodeDropdownOptions: [],
        serviceRequestCodeDropdownOptions: [],
        subServiceRequestCodeDropdownOptions: {},
        allSubReqServiceCodeDropdownOptions: [],
        bankCodeDropdownOptions: [],
        allCCChgOnCompDropdownOptions: [],
        allCCBillToCompDropdownOptions: [],
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
    },
    additionalState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
        tableData: [],
        isShowEditPanel: false,
        isShowDeleteModal: false,
        currentSelectedRow: EMPTY_COUNTER_CUSTOMER_CHARGE_ENTITY,
        selectedRows: [],
        vesselTableData: [],
        currentSelectedVesselRow: EMPTY_ADDITIONAL_CHARGE_VESSEL_ENTITY,
        forceRefresh: false
    },
    paymentModeState: {
        tableData: [],
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_COLLECTION_DETAIL_ENTITY,
        isBankCode: false,
        isPayOrderNo: false,
        isPayOrderAmount: false,
        isCreditCardNo: false,
        paymentModeHeader: EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA,
        collectionHeaderList: [],
        servicePayAmount: 0,
        isCustomsDec: false,
        isAgentDate: false,
    },
    isBackMaster: false,
    isShowEditPanel: false,
    searchCriteria: { ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA },
    isShowDetailPanel: false,
    isShowAdditionalChargePanel: false,
    isShowPaidThroughDatePanel: false,
    isShowInvoiceInfoPanel: false,
    isShowChargeOnCompanyPanel: false,
    isShowBillToCompanyPanel: false,
    isShowWaiverReasonCodePanel: false,
    isShowSuppleWaiverPanel: false,
    isShowAdjustmentPanel: false,
    isShowChargeQtyPanel: false,
    isShowExtraLaborPanel: false,
    isShowAccTerminalPanel: false,
    isShowStuffingPanel: false,
    isShowExtensionPaymentPanel: false,
    isEnabledEditWaiver: false,
    isEnabledSuppleWaiver: false,
    isEnabledWaiver: false,
    isEnabledChargeCom: false,
    isEnabledBillCom: false,
    isEnableExciseCashNo: false,
    isEnablePaidThroughDate: false,
    isEnableChargeQty: false,
    isEnableExtraLabor: false,
    isEnableAccTerminal: false,
    isEnableHoldUnhold: false,
    isEnableAgentDeliveryDate: false,
    isEnableExtensionPayment: false,
    isShowFindVesselPanel: false,
    isShowPaymentModePanel: false,
    isShowAddPaymentModePanel: false,
    isShowAgentDeliveryDatePanel: false,
    allSLCompanies: [],
    editWaiverList: [],
    suppleWaiverList: [],
    singleMultipleValidationMap: {},
    returnCntrNo: [],
    returnBlNo: "",
    paidThroughDateMap: new Map(),
    agentDeliveryDateMap: new Map(),
    extensionPaymentMap: new Map(),
    previousPaidThroughDateMap: new Map(),
    isShowSerachClose: false,
    isEnableMarkMT: false,
    isEnableDelete: false,
    isEnableAdjustment: false,
    isEnableCfsStuffing: false,
    isEnableImporiReHandling: true,
    isEnablePreview: false,
    selectedPaidThroughDateMap: new Map(),
    selectedAgentDeliveryDateMap: new Map(),
    allFormState: {},
}